export default "__VITE_ASSET__DUDWFWBf__";